/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

// O índice do grupo leva a "Todas", como o `<Navigate replace>` do legado (router.tsx).
export const Route = createFileRoute('/_app/pessoas-juridicas/')({
  beforeLoad: () => {
    throw redirect({ to: '/pessoas-juridicas/todas', replace: true });
  },
});
